import { render } from "./Handler.vue?vue&type=template&id=298e35be"
import script from "./Handler.vue?vue&type=script&lang=js"
export * from "./Handler.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__